import 'firebase/compat/app'
import 'firebase/compat/auth'
import firebase from 'firebase/compat/app'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
import 'firebase/compat/firestore'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

class Firebase {
  public auth: firebase.auth.Auth
  public ui: firebaseui.auth.AuthUI
  constructor() {
    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    const firebaseConfig = {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SNEDER_ID!,
      appId: process.env.REACT_APP_FIREBASE_APP_ID!,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID!,
    }
    firebase.initializeApp(firebaseConfig)
    this.auth = firebase.auth()

    this.ui = new firebaseui.auth.AuthUI(this.auth)
  }

  currentAuthUser() {
    return firebase.auth().currentUser
  }

  isSignedIn() {
    return Boolean(this.currentAuthUser())
  }

  renderSignIn(redirectUrl: string) {
    // FirebaseUI config.
    const uiConfig = {
      signInFlow: 'popup',
      signInSuccessUrl: redirectUrl,
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],
      tosUrl: function () {
        window.open('/tos', '_blank')
      },
      privacyPolicyUrl: function () {
        window.open('/privacy', '_blank')
      },
    }
    this.ui.start('#firebaseui-auth-container', uiConfig)
  }

  getFirestore() {
    return firebase.firestore()
  }

  getAuth() {
    return this.auth
  }

  async signOut() {
    await this.auth.signOut()
  }
}

export const fb = new Firebase()
